"use client";
import {
  Image_default
} from "./chunk-BVJ4WRGT.mjs";
import {
  Button_default
} from "./chunk-CGHW2YLJ.mjs";

// src/components/sections/NeedHelp/NeedHelp.tsx
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var NeedHelp = forwardRef(function NeedHelp2({ referId, title, description, image, buttons }, ref) {
  return /* @__PURE__ */ jsx("section", { id: referId, className: "flex text-display-0 bg-stone-600", children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col md:flex-row justify-center items-center p-40 md:p-80 px-24 md:px-24 mx-auto w-full max-w-screen-xl", children: [
    /* @__PURE__ */ jsx(
      Image_default,
      {
        src: image.path,
        alt: image.alternativeText,
        width: 400,
        height: 326
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: "flex flex-col items-center md:items-start md:ml-40",
        style: { maxWidth: 400 },
        children: [
          /* @__PURE__ */ jsx(
            "h2",
            {
              className: "mb-8 font-display text-center md:text-left text-current text-6xl leading-9 font-bold",
              dangerouslySetInnerHTML: {
                __html: title
              }
            }
          ),
          /* @__PURE__ */ jsx("p", { className: "text-center md:text-left text-current text-base leading-4 md:text-lg md:leading-[26px]", children: description }),
          /* @__PURE__ */ jsx("div", { className: "flex flex-col sm:flex-row items-center mt-24 w-full sm:w-auto", children: buttons.length > 0 && /* @__PURE__ */ jsx("div", { className: "flex flex-col md:flex-row gap-16 mt-16 md:mt-24 w-full", children: buttons == null ? void 0 : buttons.map((props, index) => /* @__PURE__ */ jsx(
            Button_default,
            {
              ...props,
              className: "w-full md:w-max"
            },
            `${props.label}-${index}`
          )) }) })
        ]
      }
    )
  ] }) });
});
var NeedHelp_default = NeedHelp;

export {
  NeedHelp_default
};
